import { RadioGroup } from '@shared/shared-shadcn-ui';
import { StepNumber } from '../step-number/step-number';
import { FormRadioButton } from '../form-radio-button/form-radio-button';
import { FormButton } from '../../../../../../../_libs/components/components';
import { cn } from '@shared/shared-utils';
import { useState } from 'react';
import ArrowRightIcon from '../../../../../../../../../public/svg/arrow-right.svg';

type Properties = {
  onSubmit: () => void;
};

const TreatmentWoundStep = ({ onSubmit }: Properties) => {
  const [selectedTreatmentWound, setSelectedTreatmentWound] = useState<
    string | null
  >(null);

  return (
    <div>
      <div className="flex justify-center lg:justify-start lg:ml-[50px] xl:ml-[150px] gap-x-6 bg-white rounded-t-lg py-10">
        <div className="mt-3">
          <StepNumber number={5} />
        </div>
        <h4 className="text-[30px] lg:text-[44px] text-ogn-blue font-bold leading-normal max-w-[970px]">
          In the past year, I have received treatment for my wound at the:
        </h4>
      </div>
      <RadioGroup
        value={selectedTreatmentWound}
        onValueChange={(value) => setSelectedTreatmentWound(value)}
        className="flex justify-center pl-[74px] lg:pl-0 lg:px-5"
      >
        <div className="grid grid-cols-1 lg:grid-cols-[auto_auto] gap-x-20 gap-y-12">
          {[
            {
              label: 'Emergency Room',
              value: '1',
            },
            {
              label: 'Primary Care Physician',
              value: '2',
            },
            {
              label: 'Podiatrist',
              value: '3',
            },
            {
              label: 'Dermatologist',
              value: '4',
            },
            {
              label: 'Wound Care Center',
              value: '5',
            },
            {
              label: 'Other',
              value: '6',
            },
            {
              label: 'I have not sought treatment for my wound',
              value: '7',
            },
          ].map((option, index, array) => (
            <FormRadioButton
              className={cn({
                'lg:col-span-2': array.length - 1 === index,
              })}
              key={option.value}
              label={option.label}
              value={option.value}
            />
          ))}
        </div>
      </RadioGroup>
      <FormButton
        className="mx-auto w-[300px] my-16 font-roboto-condensed"
        onClick={onSubmit}
        isDisabled={!selectedTreatmentWound}
      >
        Submit
        <ArrowRightIcon className="w-6 h-6" />
      </FormButton>
    </div>
  );
};

export { TreatmentWoundStep };
